import { defineComponent as _defineComponent } from 'vue'
import VLoader from '@/components/loader.vue'
import VQrCode from '@/components/QrCode.vue'
import LocationSelect from '@/components/meeting-request/location-select.vue';
import TempContainer from '@/components/meeting-request-3/temp-container.vue';

import PopupVideo from '@/components/popup-video.vue';
import { ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'tester',
  setup(__props, { expose }) {
  expose();


const popupActive = ref(false)

const modelValue = ref<any | undefined>();


const __returned__ = { popupActive, modelValue, VLoader, VQrCode, LocationSelect, TempContainer, PopupVideo, ref }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})